"use client";

import { sanitize } from "isomorphic-dompurify";
import React, { type JSX } from "react";

/**
 * Use in place of dangerouslySetInnerHTML to sanitize html before setting it
 */
export const SafelySetInnerHTML: React.FC<{
  html: string | undefined;
  tag?: keyof JSX.IntrinsicElements;
  /**
   * If the block of HTML to be sanitized is a whole document enable this to
   * keep doc tags (e.g. <html>, <head>, <body>). This also ensures style tags
   * in the head are not removed
   */
  isWholeDocument?: boolean;
  /**
   * If enabled, the target attribute will be kept during sanization.
   */
  keepTargetAttribute?: boolean;
}> = ({ html, tag, isWholeDocument = false, keepTargetAttribute = false }) => {
  if (!html) {
    return null;
  }

  const attributesWhiteList = keepTargetAttribute ? ["target"] : [];
  const sanitizeConfig = {
    WHOLE_DOCUMENT: isWholeDocument,
    ADD_ATTR: attributesWhiteList,
  };

  const Tag = tag ?? "div";
  const sanitizedHtml = sanitize(html, sanitizeConfig);
  return <Tag dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};
